module.exports = __webpack_public_path__ + "img/main_yd.e854ce4e.jpg";